document.documentElement.classList.add('js');

function normalizeProductLinks(html) {
  return html
    .replaceAll('https://www.thecompanystore.com/rewards', '/pages/comfort-rewards')
    .replaceAll('https://www.thecompanystore.com/how-to-choose-outdoor-patio-cushions.html', '/pages/outdoor-patio-cushions-guide')
    .replaceAll('/law-labels.html#', '/pages/law-labels#')
    .replaceAll('/law-labels.html', '/pages/law-labels');
}

document.querySelectorAll('[data-product-root]').forEach(root => {
  const variants = JSON.parse(root.querySelector('[data-variants]').textContent);
  const select = root.querySelector('[data-variant-select]');
  const currency = root.dataset.currency || 'USD';
  const money = value => new Intl.NumberFormat(root.dataset.locale || 'en', {style:'currency',currency}).format(value / 100);
  const optionGroups = [...root.querySelectorAll('[data-option-index]')];
  const selected = optionGroups.map(group => group.querySelector('[data-option-value].is-selected')?.dataset.optionValue || '');
  const galleryButtons = [...root.querySelectorAll('[data-gallery-image]')];
  let activeImage = 0;

  const colorFor = value => {
    const name = value.toLowerCase();
    const colors = {white:'#f5f4f1',ivory:'#eee9dc',cream:'#eee7d8',natural:'#dfd4c3',tan:'#c6ad8b',beige:'#c9b99f',brown:'#806451',chocolate:'#4b382e',black:'#292929',gray:'#a5a7a6',grey:'#a5a7a6',silver:'#c5c7c5',blue:'#7893ad',navy:'#263c56',green:'#7f927d',sage:'#aab5a1',red:'#a7514b',pink:'#d2aaa9',purple:'#9586a6',yellow:'#dfc66f',orange:'#c88255'};
    for (const [key, color] of Object.entries(colors)) if (name.includes(key)) return color;
    return /stripe|check|plaid|floral|print|pattern|multi/i.test(name) ? 'linear-gradient(135deg,#e8e5dd 0 25%,#75889a 25% 38%,#f3f1eb 38% 62%,#75889a 62% 75%,#e8e5dd 75%)' : '#d8d3ca';
  };
  root.querySelectorAll('[data-swatch-label]').forEach(swatch => { swatch.style.background = colorFor(swatch.dataset.swatchLabel); });

  function currentVariant() { return variants.find(variant => variant.options.every((value,index) => value === selected[index])) || null; }
  function setImage(src, alt, button) {
    const image = root.querySelector('#ProductHero');
    if (!image || !src) return;
    image.removeAttribute('srcset'); image.src = src; image.alt = alt || '';
    const imagePath = value => { try { return new URL(value,location.origin).pathname; } catch { return value; } };
    const visible = galleryButtons.filter(item => !item.hidden);
    const activeButton = button || galleryButtons.find(item => imagePath(item.dataset.galleryImage) === imagePath(src)) || visible[0];
    activeImage = Math.max(0,visible.indexOf(activeButton));
    galleryButtons.forEach(item => item.setAttribute('aria-pressed',String(item === activeButton)));
    const counter = root.querySelector('[data-gallery-counter]');
    if (counter && visible.length) counter.textContent = `${activeImage+1} / ${visible.length}`;
  }
  function filterGallery(color) {
    let firstVisible = null;
    galleryButtons.forEach(button => {
      const alt = button.dataset.imageAlt || '';
      const show = !color || !alt || alt.toLowerCase().includes(color.toLowerCase());
      button.hidden = !show;
      if (show && !firstVisible) firstVisible = button;
    });
    if (firstVisible) setImage(firstVisible.dataset.galleryImage,firstVisible.dataset.imageAlt,firstVisible);
  }
  function renderVariant(variant, updateUrl = true) {
    if (!variant) return;
    selected.splice(0,selected.length,...variant.options);
    optionGroups.forEach((group,index) => {
      group.querySelector('[data-option-current]').textContent = variant.options[index];
      group.querySelectorAll('[data-option-value]').forEach(button => {
        const active = button.dataset.optionValue === variant.options[index];
        button.classList.toggle('is-selected',active); button.setAttribute('aria-pressed',String(active));
      });
    });
    select.value = variant.id;
    const price = root.querySelector('[data-price]'); if (price) price.textContent = money(variant.price);
    const comparison = root.querySelector('[data-compare-price]');
    const discount = variant.compare_at_price > variant.price && variant.compare_at_price > 0;
    if (comparison) { comparison.hidden = !discount; comparison.textContent = discount ? money(variant.compare_at_price) : ''; }
    const badge = root.querySelector('[data-discount-badge]');
    if (badge) { badge.hidden = !discount; badge.textContent = discount ? `${Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price)}% OFF` : ''; }
    const savings = root.querySelector('[data-savings]'); if (savings) savings.textContent = money(variant.compare_at_price - variant.price);
    const sku = root.querySelector('[data-sku]'); if (sku) sku.textContent = `Item #${variant.sku || ''}`;
    const add = root.querySelector('[data-add-button]'); if (add) { add.disabled = !variant.available; add.textContent = variant.available ? 'Add to Bag' : 'Sold Out'; }
    const colorIndex = optionGroups.findIndex(group => /colou?r/i.test(group.dataset.optionName));
    filterGallery(colorIndex < 0 ? '' : variant.options[colorIndex]);
    if (variant.featured_image?.src) setImage(variant.featured_image.src,variant.featured_image.alt);
    if (updateUrl) { const url = new URL(location.href); url.searchParams.set('variant',variant.id); history.replaceState({},'',url); }
    document.dispatchEvent(new CustomEvent('product:variant-change',{detail:{product:root.dataset.productHandle,variant}}));
  }
  optionGroups.forEach((group,index) => group.addEventListener('click',event => {
    const button = event.target.closest('[data-option-value]'); if (!button) return;
    selected[index] = button.dataset.optionValue;
    const variant = currentVariant();
    if (!variant) {
      const status = root.querySelector('[data-option-status]'); status.hidden = false; status.textContent = 'That option combination is unavailable. Please choose another option.'; return;
    }
    const status = root.querySelector('[data-option-status]'); status.hidden = true; status.textContent = '';
    renderVariant(variant);
  }));
  galleryButtons.forEach(button => button.addEventListener('click',() => setImage(button.dataset.galleryImage,button.dataset.imageAlt,button)));
  root.querySelector('[data-gallery-previous]')?.addEventListener('click',() => cycleImage(-1));
  root.querySelector('[data-gallery-next]')?.addEventListener('click',() => cycleImage(1));
  function cycleImage(direction) {
    const visible = galleryButtons.filter(button => !button.hidden); if (!visible.length) return;
    const current = visible.findIndex(button => button.getAttribute('aria-pressed') === 'true');
    const next = visible[(current + direction + visible.length) % visible.length]; setImage(next.dataset.galleryImage,next.dataset.imageAlt,next);
  }
  root.querySelectorAll('[data-quantity-step]').forEach(button => button.addEventListener('click',() => {
    const input = root.querySelector('.product-quantity input'); input.value = String(Math.max(1,(Number(input.value)||1)+Number(button.dataset.quantityStep))); input.dispatchEvent(new Event('change',{bubbles:true}));
  }));
  const initialVariant = variants.find(variant => String(variant.id) === select.value) || currentVariant();
  if (initialVariant) renderVariant(initialVariant,false);

  loadSourceDetails();
  async function loadSourceDetails() {
    try {
      const response = await fetch(root.dataset.detailsUrl,{credentials:'same-origin'}); if (!response.ok) return;
      const data = await response.json();
      const record = data.products?.[root.dataset.productHandle]; if (!record) return;
      const details = root.querySelector('[data-product-source-details]');
      const fallback = root.querySelector('.product-description-fallback');
      const panels = record.panels || {};
      if (panels.overview) {
        fallback?.remove();
        const overview = document.createElement('section'); overview.className = 'product-source-details__overview'; overview.innerHTML = normalizeProductLinks(panels.overview);
        const title = document.createElement('h2'); title.textContent = 'Product Overview'; details.append(title,overview);
      }
      const accordion = document.createElement('div'); accordion.className = 'product-source-details__panels';
      Object.entries(panels).forEach(([title,html]) => {
        if (title === 'overview' || /review|question|rating/i.test(title)) return;
        const item = document.createElement('details'); item.className = 'product-detail';
        const summary = document.createElement('summary'); summary.textContent = title;
        const content = document.createElement('div'); content.innerHTML = normalizeProductLinks(html);
        item.append(summary,content); accordion.append(item);
      });
      if (accordion.childElementCount) details.append(accordion);
      if (details.childElementCount) details.hidden = false;
      if (record.collection?.length) await renderCollection(record.collection);
    } catch (error) { console.warn('Product source details were unavailable.',error); }
  }
  async function renderCollection(items) {
    const section = root.querySelector('[data-product-collection]');
    const heading = document.createElement('h2'); heading.textContent = 'Shop the Collection';
    const form = document.createElement('form'); form.action = '/cart/add'; form.method = 'post'; form.className = 'product-collection__form';
    const list = document.createElement('div'); list.className = 'product-collection__list';
    const mapped = await Promise.all(items.map(async item => {
      const handle = item.shopifyHandle || `tcs-${String(item.sourceProductId).toLowerCase()}`;
      try {
        const response = await fetch(`/products/${encodeURIComponent(handle)}.js`,{headers:{Accept:'application/json'}});
        if (!response.ok) return null;
        const product = await response.json();
        const key = String(item.sku || '').toLowerCase();
        const initial = product.variants.find(variant => String(variant.sku || '').toLowerCase() === key) || product.variants.find(variant => variant.available) || product.variants[0];
        if (!initial) return null;
        return {item,product,initial};
      } catch { return null; }
    }));
    mapped.filter(Boolean).forEach(({item,product,initial}) => {
      const card = document.createElement('article'); card.className = 'product-collection__item'; card.dataset.collectionProduct = product.id;
      const checkbox = document.createElement('input'); checkbox.type = 'checkbox'; checkbox.checked = false; checkbox.setAttribute('aria-label',`Add ${product.title} to bag`);
      const imageLink = document.createElement('a'); imageLink.href = `/products/${product.handle}`;
      const image = document.createElement('img'); image.src = item.image || product.featured_image; image.alt = product.title; image.loading = 'lazy'; imageLink.append(image);
      const info = document.createElement('div');
      const title = document.createElement('h3'); const link = document.createElement('a'); link.href = imageLink.href; link.textContent = item.label || product.title; title.append(link);
      const price = document.createElement('p'); price.textContent = money(initial.price);
      const selectors = document.createElement('div'); selectors.className = 'product-collection__selectors';
      const cardState = {variant:initial,fields:[]};
      product.options.forEach((name,index) => {
        const field = document.createElement('select'); field.setAttribute('aria-label',`${name} for ${product.title}`);
        const values = [...new Set(product.variants.map(variant => variant.options[index]))];
        values.forEach(value => { const option = document.createElement('option'); option.value = value; option.textContent = value; option.selected = initial.options[index] === value; field.append(option); });
        field.addEventListener('change',() => {
          const chosen = cardState.fields.map(select => select.value);
          const matched = product.variants.find(variant => variant.options.every((value,i) => value === chosen[i]));
          if (!matched) return;
          cardState.variant = matched; price.textContent = money(matched.price); checkbox.disabled = !matched.available;
          if (matched.featured_image?.src) image.src = matched.featured_image.src;
          updateCollectionItems();
        });
        cardState.fields.push(field); selectors.append(field);
      });
      checkbox.disabled = !initial.available;
      card.append(checkbox,imageLink,info); info.append(title,price,selectors);
      card._collectionState = cardState; checkbox.addEventListener('change',updateCollectionItems);
      list.append(card);
    });
    if (!list.childElementCount) return;
    const hiddenInputs = document.createElement('div'); hiddenInputs.hidden = true; hiddenInputs.dataset.collectionInputs = '';
    const actions = document.createElement('div'); actions.className = 'product-collection__actions';
    const add = document.createElement('button'); add.type = 'submit'; add.textContent = 'Add selected to bag'; actions.append(add);
    form.append(list,hiddenInputs,actions); section.append(heading,form); section.hidden = false;
    function updateCollectionItems() {
      hiddenInputs.replaceChildren(); let index = 0;
      list.querySelectorAll('.product-collection__item').forEach(card => {
        const checkbox = card.querySelector('input[type="checkbox"]'); if (!checkbox.checked || checkbox.disabled) return;
        const id = document.createElement('input'); id.type = 'hidden'; id.name = `items[${index}][id]`; id.value = card._collectionState.variant.id;
        const quantity = document.createElement('input'); quantity.type = 'hidden'; quantity.name = `items[${index}][quantity]`; quantity.value = '1'; hiddenInputs.append(id,quantity); index++;
      });
      add.disabled = index === 0;
    }
    updateCollectionItems();
  }
});

const navItems=[...document.querySelectorAll('[data-nav-item]')];
const menuBackdrop=document.querySelector('[data-menu-backdrop]');
let navCloseTimer;
function syncNavigationState(){
  const openItems=navItems.filter(item=>item.open);
  navItems.forEach(item=>item.querySelector(':scope > summary')?.setAttribute('aria-expanded',String(item.open)));
  if(menuBackdrop){
    menuBackdrop.hidden=openItems.length===0;
    const nav=document.querySelector('[data-main-nav]');
    if(nav&&openItems.length)document.documentElement.style.setProperty('--menu-backdrop-top',`${nav.getBoundingClientRect().bottom}px`);
  }
  openItems.forEach(item=>{
    const nav=document.querySelector('[data-main-nav]');
    const panel=item.querySelector(':scope > .mega-menu');
    if(!nav||!panel)return;
    panel.style.left='0px';
    const navRect=nav.getBoundingClientRect();
    const triggerRect=item.getBoundingClientRect();
    const maxLeft=Math.max(0,nav.clientWidth-panel.getBoundingClientRect().width);
    panel.style.left=`${Math.max(0,Math.min(triggerRect.left-navRect.left,maxLeft))}px`;
  });
}
function closeNavigation(returnFocus=false){
  clearTimeout(navCloseTimer);
  navItems.forEach(item=>{item.open=false;});
  syncNavigationState();
  if(returnFocus)document.querySelector('[data-nav-item][data-last-open] > summary')?.focus();
}
navItems.forEach(menu=>{
  menu.querySelector(':scope > summary')?.addEventListener('click',event=>{
    if(!matchMedia('(min-width: 900px)').matches)return;
    event.preventDefault();
    clearTimeout(navCloseTimer);
    navItems.forEach(item=>{if(item!==menu){item.open=false;item.removeAttribute('data-last-open');}});
    menu.open=true;
    menu.setAttribute('data-last-open','');
    syncNavigationState();
  });
  menu.addEventListener('mouseenter',()=>{
    if(!matchMedia('(min-width: 900px)').matches)return;
    clearTimeout(navCloseTimer);
    navItems.forEach(item=>{if(item!==menu){item.open=false;item.removeAttribute('data-last-open');}});
    menu.open=true;
    menu.setAttribute('data-last-open','');
    syncNavigationState();
  });
  menu.addEventListener('mouseleave',()=>{
    if(!matchMedia('(min-width: 900px)').matches)return;
    navCloseTimer=setTimeout(()=>{menu.open=false;menu.removeAttribute('data-last-open');syncNavigationState();},140);
  });
  menu.addEventListener('toggle',syncNavigationState);
  menu.addEventListener('focusin',()=>{
    clearTimeout(navCloseTimer);
    if(matchMedia('(min-width: 900px)').matches){menu.open=true;menu.setAttribute('data-last-open','');syncNavigationState();}
  });
  menu.addEventListener('focusout',event=>{
    if(menu.contains(event.relatedTarget))return;
    menu.open=false;
    menu.removeAttribute('data-last-open');
    syncNavigationState();
  });
});
window.addEventListener('resize',syncNavigationState,{passive:true});
menuBackdrop?.addEventListener('click',()=>closeNavigation());
document.addEventListener('keydown',event=>{
  if(event.key!=='Escape')return;
  const activeNav=document.querySelector('[data-nav-item][open]');
  const mobileMenu=document.querySelector('.mobile-menu[open]');
  if(activeNav){activeNav.open=false;activeNav.removeAttribute('data-last-open');syncNavigationState();activeNav.querySelector(':scope > summary')?.focus();}
  if(mobileMenu){mobileMenu.open=false;mobileMenu.querySelector(':scope > summary')?.focus();}
});
document.querySelectorAll('.mobile-menu').forEach(menu => {
  menu.addEventListener('toggle', () => {
    document.body.classList.toggle('mobile-navigation-open',menu.open);
    menu.querySelector(':scope > summary')?.setAttribute('aria-expanded',String(menu.open));
  });
  menu.addEventListener('click', event => {if(event.target === menu)menu.open=false;});
});
window.addEventListener('resize',syncNavigationState,{passive:true});

const favoritesKey='tcs-favorites-v1';
const readFavorites=()=>{try{return new Set(JSON.parse(localStorage.getItem(favoritesKey)||'[]').map(String));}catch{return new Set();}};
const paintFavorite=button=>{
  const selected=readFavorites().has(String(button.dataset.favoriteId));
  button.classList.toggle('is-favorite',selected);
  button.setAttribute('aria-pressed',String(selected));
  button.setAttribute('aria-label',`${selected?'Remove':'Add'} ${button.dataset.favoriteTitle||button.closest('[data-product-card], [data-cart-quick-card]')?.querySelector('h3')?.textContent.trim()||'product'} ${selected?'from':'to'} favorites`);
};
document.querySelectorAll('[data-product-favorite]').forEach(paintFavorite);
new MutationObserver(records=>records.forEach(record=>record.addedNodes.forEach(node=>{
  if(node.nodeType!==Node.ELEMENT_NODE)return;
  if(node.matches?.('[data-product-favorite]'))paintFavorite(node);
  node.querySelectorAll?.('[data-product-favorite]').forEach(paintFavorite);
}))).observe(document.documentElement,{childList:true,subtree:true});
document.querySelectorAll('[data-product-recommendations][data-url]').forEach(section=>{
  (async()=>{
    try{
      const response=await fetch(section.dataset.url,{credentials:'same-origin'});
      if(!response.ok)return;
      const html=document.createElement('div');html.innerHTML=await response.text();
      const recommendations=html.querySelector('[data-recommendation-cards]');
      if(!recommendations?.children.length){section.hidden=true;return;}
      const sourceHeading=html.querySelector('h2');
      const heading=section.querySelector('h2');
      if(sourceHeading&&heading)heading.textContent=sourceHeading.textContent;
      const target=section.querySelector('[data-recommendation-cards]');
      if(target)target.replaceWith(recommendations);
    }catch(error){console.error('Product recommendations could not be loaded.',error);}
  })();
});
document.addEventListener('click',event=>{
  const favorite=event.target.closest('[data-product-favorite]');
  if(favorite){
    event.preventDefault();event.stopPropagation();
    const favorites=readFavorites(),id=String(favorite.dataset.favoriteId);
    if(favorites.has(id))favorites.delete(id);else favorites.add(id);
    try{localStorage.setItem(favoritesKey,JSON.stringify([...favorites]));}catch{}
    document.querySelectorAll(`[data-product-favorite][data-favorite-id="${CSS.escape(id)}"]`).forEach(paintFavorite);
    return;
  }
  const swatch=event.target.closest('[data-product-swatch]');
  if(swatch){
    event.preventDefault();
    const card=swatch.closest('.product-card'),variantId=swatch.dataset.variantId;
    if(!card||!variantId)return;
    card.querySelectorAll('[data-product-swatch]').forEach(button=>{const selected=button===swatch;button.classList.toggle('is-selected',selected);button.setAttribute('aria-pressed',String(selected));});
    card.querySelectorAll('.product-card__image, h3 a').forEach(link=>{const url=new URL(link.href,location.origin);url.searchParams.set('variant',variantId);link.href=url.pathname+url.search+url.hash;});
    const image=card.querySelector('.product-card__image img');
    if(image&&swatch.dataset.variantImage){image.src=swatch.dataset.variantImage;image.removeAttribute('srcset');}
    const price=card.querySelector('[data-card-price]');
    if(price&&swatch.dataset.variantPrice)price.textContent=swatch.dataset.variantPrice;
    const compare=card.querySelector('[data-card-compare-price]'),savings=card.querySelector('[data-card-savings]');
    if(compare&&savings){
      const hasCompare=Boolean(swatch.dataset.variantComparePrice);
      compare.textContent=swatch.dataset.variantComparePrice||'';compare.hidden=!hasCompare;savings.hidden=!hasCompare;
      card.querySelector('.product-card__price')?.classList.toggle('is-sale',hasCompare);
      card.querySelector('.discount-badge')?.toggleAttribute('hidden',!hasCompare);
      const discount=card.querySelector('[data-discount-badge]');
      if(hasCompare){const parse=value=>Number(value.replace(/[^\d.,]/g,'').replace(/,(?=\d{3})/g,'').replace(',','.'));const oldPrice=parse(swatch.dataset.variantComparePrice),newPrice=parse(swatch.dataset.variantPrice),percentage=Math.round((oldPrice-newPrice)*100/oldPrice);savings.textContent=`${percentage}% Off`;if(discount){discount.textContent=`${percentage}% OFF`;discount.hidden=false;}}
      else if(discount)discount.hidden=true;
    }
    return;
  }
  const more=event.target.closest('[data-swatch-more]');
  if(more){
    const expanded=more.getAttribute('aria-expanded')==='true',group=more.closest('.product-card__swatches, .cart-recommendation-card__swatches');
    group?.querySelectorAll('.is-extra-swatch').forEach(button=>{button.hidden=expanded;});
    more.setAttribute('aria-expanded',String(!expanded));more.textContent=expanded?`+${more.dataset.moreCount}`:'−';more.setAttribute('aria-label',expanded?`Show ${more.dataset.moreCount} more colors`:'Show fewer colors');
  }
});

document.querySelectorAll('[data-home-carousel]').forEach(carousel => {
  const track=carousel.querySelector('[data-carousel-track]');
  const previous=carousel.querySelector('[data-carousel-previous]');
  const next=carousel.querySelector('[data-carousel-next]');
  if(!track||!previous||!next)return;
  const progress=carousel.querySelector('[data-carousel-progress]');
  if(carousel.matches('[data-browsing-carousel]')){
    const storageKey='tcs-recently-viewed-v1';
    try{
      const recent=JSON.parse(sessionStorage.getItem(storageKey)||'[]');
      const slides=[...track.querySelectorAll('[data-product-handle]')];
      const rank=new Map(recent.map((handle,index)=>[handle,index]));
      slides.sort((a,b)=>(rank.get(b.dataset.productHandle)??-1)-(rank.get(a.dataset.productHandle)??-1));
      slides.forEach(slide=>track.append(slide));
    }catch{}
  }
  const update=()=>{
    const max=Math.max(0,track.scrollWidth-track.clientWidth);
    previous.disabled=track.scrollLeft<=2;
    next.disabled=track.scrollLeft>=max-2;
    if(progress)progress.style.marginLeft=`${max>0?(track.scrollLeft/max)*66:0}%`;
  };
  const step=()=>{
    const slide=track.querySelector('.home-social-card, .home-carousel__slide');
    return Math.max(220,(slide?.getBoundingClientRect().width||track.clientWidth*.82)+parseFloat(getComputedStyle(track).columnGap||0));
  };
  previous.addEventListener('click',()=>track.scrollBy({left:-step(),behavior:'smooth'}));
  next.addEventListener('click',()=>track.scrollBy({left:step(),behavior:'smooth'}));
  track.addEventListener('scroll',update,{passive:true});
  window.addEventListener('resize',update,{passive:true});
  update();
});

const productRoot=document.querySelector('[data-product-root][data-product-handle]');
if(productRoot){
  try{
    const storageKey='tcs-recently-viewed-v1';
    const recent=JSON.parse(sessionStorage.getItem(storageKey)||'[]');
    const handle=productRoot.dataset.productHandle;
    sessionStorage.setItem(storageKey,JSON.stringify([handle,...recent.filter(item=>item!==handle)].slice(0,20)));
  }catch{}
}

document.querySelectorAll('[data-home-search-query]').forEach(button=>button.addEventListener('click',()=>{
  const form=button.closest('.home-coach')?.querySelector('form');
  const input=form?.querySelector('input[name="q"]');
  if(!form||!input)return;
  input.value=button.dataset.homeSearchQuery||'';
  form.requestSubmit();
}));

document.querySelectorAll('[data-home-video]').forEach(video=>{
  const wrapper=video.closest('[data-home-video-wrap]');
  if(!wrapper)return;
  if(matchMedia('(prefers-reduced-motion: reduce)').matches){video.pause();return;}
  const showVideo=()=>wrapper.classList.add('is-playing');
  video.addEventListener('loadeddata',showVideo,{once:true});
  video.addEventListener('error',()=>wrapper.classList.remove('is-playing'));
  video.play().catch(()=>wrapper.classList.remove('is-playing'));
});

// Remember the banner dismissal so it stays out of the way during future page visits.
const cookieBanner=document.querySelector('[data-cookie-banner]');
if(cookieBanner){
  const cookieBannerDismissalKey='tcs-cookie-banner-accepted';
  try{cookieBanner.hidden=window.localStorage.getItem(cookieBannerDismissalKey)==='true';}catch{}
  cookieBanner.querySelector('[data-cookie-dismiss]')?.addEventListener('click',()=>{
    cookieBanner.hidden=true;
    try{window.localStorage.setItem(cookieBannerDismissalKey,'true');}catch{}
  });
}

const cartDrawer=document.querySelector('[data-cart-drawer]');
if(cartDrawer){
  const backdrop=document.querySelector('[data-cart-backdrop]');
  const closeButton=cartDrawer.querySelector('[data-cart-close]');
  const drawerTitle=cartDrawer.querySelector('[data-cart-drawer-title]');
  const linesRoot=cartDrawer.querySelector('[data-cart-lines]');
  const subtotalRoot=cartDrawer.querySelector('[data-cart-subtotal]');
  const footerCount=cartDrawer.querySelector('[data-cart-footer-count]');
  const cartError=cartDrawer.querySelector('[data-cart-error]');
  const drawerEmpty=cartDrawer.querySelector('[data-cart-drawer-empty]');
  const cartRoot=window.Shopify?.routes?.root||'/';
  const cartUrl=(path)=>`${cartRoot}${path}`;
  let drawerOpener=null;
  let drawerCloseTimer=0;
  let cartBusy=false;
  let recommendationsFor='';

  const formatMoney=(amount,currency)=>new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:currency||'USD'}).format((Number(amount)||0)/100);
  const setError=(message='')=>{cartError.textContent=message;cartError.hidden=!message;};
  const itemWord=count=>`${count} ${count===1?'Item':'Items'}`;

  function openCartDrawer(opener=document.activeElement){
    window.clearTimeout(drawerCloseTimer);
    drawerOpener=opener instanceof HTMLElement?opener:null;
    backdrop.hidden=false;
    cartDrawer.hidden=false;
    cartDrawer.setAttribute('aria-hidden','false');
    document.body.classList.add('cart-drawer-open');
    requestAnimationFrame(()=>{backdrop.classList.add('is-open');cartDrawer.classList.add('is-open');closeButton.focus({preventScroll:true});});
    loadCartRecommendations();
  }

  function closeCartDrawer({restoreFocus=true}={}){
    if(cartDrawer.hidden)return;
    cartDrawer.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden','true');
    document.body.classList.remove('cart-drawer-open');
    drawerCloseTimer=window.setTimeout(()=>{cartDrawer.hidden=true;backdrop.hidden=true;},270);
    if(restoreFocus&&drawerOpener?.isConnected)drawerOpener.focus({preventScroll:true});
  }

  function makeLine(item,currency){
    const article=document.createElement('article');article.className='cart-drawer-line';article.dataset.cartLine='';article.dataset.lineKey=item.key||'';
    const imageLink=document.createElement('a');imageLink.className='cart-drawer-line__image';imageLink.href=item.url||'#';
    const imageUrl=item.image||item.featured_image?.url||item.featured_image||'';
    if(imageUrl){const image=document.createElement('img');image.src=imageUrl;image.alt=item.product_title||'';image.loading='lazy';imageLink.append(image);}
    const details=document.createElement('div');details.className='cart-drawer-line__details';
    const heading=document.createElement('h3');const productLink=document.createElement('a');productLink.href=item.url||'#';productLink.textContent=item.product_title||item.title||'';heading.append(productLink);details.append(heading);
    const options=Array.isArray(item.options_with_values)?item.options_with_values:[];
    for(const option of options){if(!option?.value||option.value==='Default Title')continue;const row=document.createElement('p');const name=String(option.name||'Option');row.textContent=/^size$/i.test(name)?`Size: ${option.value}`:/^colou?r$/i.test(name)?`Color: ${option.value}`:`${name}: ${option.value}`;details.append(row);}
    for(const property of Object.entries(item.properties||{})){const [name,value]=property;if(!value||name.startsWith('_'))continue;const row=document.createElement('p');row.textContent=`${name}: ${value}`;details.append(row);}
    if(item.sku){const sku=document.createElement('p');sku.className='cart-drawer-line__sku';sku.textContent=item.sku;details.append(sku);}
    const bottom=document.createElement('div');bottom.className='cart-drawer-line__bottom';const quantity=document.createElement('span');quantity.textContent=`Qty: ${item.quantity}`;const remove=document.createElement('button');remove.type='button';remove.className='cart-line-remove';remove.dataset.cartRemove='';remove.dataset.lineKey=item.key||'';remove.setAttribute('aria-label',`Remove ${item.product_title||item.title||'item'} from bag`);remove.textContent='Remove';const price=document.createElement('strong');price.textContent=formatMoney(item.final_line_price??item.line_price??(item.final_price||item.price||0)*item.quantity,currency);bottom.append(quantity,remove,price);details.append(bottom);
    article.append(imageLink,details);return article;
  }

  async function refreshCart({open=false,opener=document.activeElement}={}){
    const response=await fetch(cartUrl('cart.js'),{headers:{Accept:'application/json'},credentials:'same-origin',cache:'no-store'});
    if(!response.ok)throw new Error('We could not refresh your bag. Please try again.');
    const cart=await response.json();
    window.__tcsCart=cart;
    linesRoot.replaceChildren(...cart.items.map(item=>makeLine(item,cart.currency)));
    linesRoot.hidden=cart.item_count===0;
    if(drawerEmpty)drawerEmpty.hidden=cart.item_count!==0;
    drawerTitle.textContent=cart.item_count?`${itemWord(cart.item_count)} Added to Bag`:'Your Bag';
    footerCount.textContent=`${itemWord(cart.item_count)} in Bag`;
    subtotalRoot.textContent=formatMoney(cart.total_price,cart.currency);
    document.querySelectorAll('.header-bag__count').forEach(node=>{node.textContent=String(cart.item_count);});
    document.querySelectorAll('.header-bag').forEach(node=>node.setAttribute('aria-label',`Shopping bag, ${cart.item_count} items`));
    cartDrawer.querySelectorAll('[data-cart-quick-card]').forEach(card=>{if(cart.items.some(item=>String(item.product_id)===card.dataset.productId))card.closest('.cart-drawer-carousel__slide')?.remove();});
    if(!cart.item_count){const related=cartDrawer.querySelector('[data-cart-recommendation-group="related"]');if(related)related.hidden=true;recommendationsFor='';}
    if(open)openCartDrawer(opener);
    else if(!cartDrawer.hidden)loadCartRecommendations();
    await refreshCartPage();
    return cart;
  }

  async function refreshCartPage(){
    const currentCart=document.querySelector('.cart-page');
    if(!currentCart)return;
    try{
      const response=await fetch(location.href,{credentials:'same-origin',cache:'no-store'});if(!response.ok)return;
      const html=await response.text();const parsed=new DOMParser().parseFromString(html,'text/html');const next=parsed.querySelector('.cart-page');if(next)currentCart.replaceWith(next);
    }catch{}
  }

  async function loadCartRecommendations(){
    const cartItem=window.__tcsCart?.items?.[0];
    const productId=cartItem?.product_id||linesRoot.querySelector('[data-line-key]')?.dataset.productId;
    if(!productId||recommendationsFor===String(productId))return;
    recommendationsFor=String(productId);
    const group=cartDrawer.querySelector('[data-cart-recommendation-group="related"]');
    const track=group.querySelector('[data-cart-recommendation-track]');
    const endpoint=new URL(cartUrl('recommendations/products'),location.origin);
    endpoint.search=new URLSearchParams({section_id:'cart-drawer-recommendations',product_id:productId,limit:'10',intent:'related'}).toString();
    try{
      const response=await fetch(endpoint,{headers:{Accept:'text/html'},credentials:'same-origin'});if(!response.ok)return;
      const html=await response.text();const parsed=new DOMParser().parseFromString(html,'text/html');const results=parsed.querySelector('[data-cart-recommendation-results]');
      if(!results?.children.length)return;
      track.replaceChildren(...[...results.children].map(child=>child.cloneNode(true)));
      group.hidden=false;updateCartCarousel(group);
    }catch{}
  }

  function updateCartCarousel(carousel){
    const track=carousel.querySelector('[data-cart-recommendation-track], [data-cart-picks-track]');if(!track)return;
    const previous=carousel.querySelector('[data-cart-carousel-previous]');const next=carousel.querySelector('[data-cart-carousel-next]');if(!previous||!next)return;
    const max=Math.max(0,track.scrollWidth-track.clientWidth);previous.disabled=track.scrollLeft<=2;next.disabled=track.scrollLeft>=max-2;
  }

  document.addEventListener('submit',async event=>{
    const form=event.target;
    if(!(form instanceof HTMLFormElement)||!form.action.match(/\/cart\/add(?:\.js)?(?:\?|$)/))return;
    event.preventDefault();if(cartBusy)return;
    const submitter=event.submitter;cartBusy=true;if(submitter instanceof HTMLButtonElement)submitter.disabled=true;setError('');
    try{
      const response=await fetch(cartUrl('cart/add.js'),{method:'POST',body:new FormData(form,submitter||undefined),headers:{Accept:'application/json'},credentials:'same-origin'});
      const result=await response.json();if(!response.ok)throw new Error(result.description||result.message||'We could not add that item. Please check the selected option and try again.');
      window.__tcsLastCart={items:[{product_id:result.product_id}]};recommendationsFor='';await refreshCart({open:true,opener:submitter||form});
      form.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true,detail:{item:result}}));
    }catch(error){setError(error.message||'We could not add that item. Please try again.');openCartDrawer(submitter||form);}
    finally{cartBusy=false;if(submitter instanceof HTMLButtonElement)submitter.disabled=false;}
  });

  document.addEventListener('click',async event=>{
    const close=event.target.closest('[data-cart-close], [data-cart-continue]');
    if(close){closeCartDrawer();return;}
    if(event.target===backdrop){closeCartDrawer({restoreFocus:false});return;}

    const remove=event.target.closest('[data-cart-remove]');
    if(remove){
      event.preventDefault();if(cartBusy)return;
      const key=remove.dataset.lineKey||remove.closest('[data-cart-line], [data-cart-page-line]')?.dataset.lineKey;
      if(!key)return;
      cartBusy=true;if(remove instanceof HTMLButtonElement)remove.disabled=true;remove.setAttribute('aria-disabled','true');setError('');
      try{
        const response=await fetch(cartUrl('cart/change.js'),{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},credentials:'same-origin',body:JSON.stringify({id:key,quantity:0})});
        const result=await response.json();if(!response.ok)throw new Error(result.description||result.message||'We could not remove this item. Please try again.');
        await refreshCart();
      }catch(error){
        if(remove instanceof HTMLAnchorElement&&remove.href){location.assign(remove.href);return;}
        setError(error.message||'We could not remove this item. Please try again.');
      }
      finally{cartBusy=false;if(remove instanceof HTMLButtonElement)remove.disabled=false;remove.removeAttribute('aria-disabled');}
      return;
    }

    const arrow=event.target.closest('[data-cart-carousel-previous], [data-cart-carousel-next]');
    if(arrow){const carousel=arrow.closest('.cart-drawer-carousel');const track=carousel?.querySelector('[data-cart-recommendation-track], [data-cart-picks-track]');if(!track)return;const slide=track.querySelector('.cart-drawer-carousel__slide');const step=(slide?.getBoundingClientRect().width||track.clientWidth*.8)+20;track.scrollBy({left:arrow.hasAttribute('data-cart-carousel-next')?step:-step,behavior:'smooth'});return;}

    const swatch=event.target.closest('[data-cart-recommendation-variant]');
    if(swatch){const card=swatch.closest('[data-cart-quick-card]');if(!card)return;card.querySelectorAll('[data-cart-recommendation-variant]').forEach(button=>{const selected=button===swatch;button.classList.toggle('is-selected',selected);button.setAttribute('aria-pressed',String(selected));});const add=card.querySelector('[data-cart-quick-add]');if(add){add.dataset.variantId=swatch.dataset.cartRecommendationVariant;add.setAttribute('aria-label',`Add ${card.querySelector('h3')?.textContent.trim()||'product'} in ${swatch.title} to bag`);}const image=card.querySelector('.cart-recommendation-card__image img');if(image&&swatch.dataset.variantImage){image.src=swatch.dataset.variantImage;image.removeAttribute('srcset');}card.querySelectorAll('.cart-recommendation-card__image, h3 a').forEach(link=>{const url=new URL(link.href,location.origin);url.searchParams.set('variant',swatch.dataset.cartRecommendationVariant);link.href=url.pathname+url.search+url.hash;});return;}

    const quickAdd=event.target.closest('[data-cart-quick-add]');
    if(quickAdd){if(cartBusy)return;cartBusy=true;quickAdd.disabled=true;setError('');try{const response=await fetch(cartUrl('cart/add.js'),{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},credentials:'same-origin',body:JSON.stringify({items:[{id:Number(quickAdd.dataset.variantId),quantity:1}]})});const result=await response.json();if(!response.ok)throw new Error(result.description||result.message||'We could not add that item. Please try again.');window.__tcsLastCart={items:[{product_id:result.items?.[0]?.product_id||result.product_id}]};recommendationsFor='';await refreshCart({open:true,opener:quickAdd});}catch(error){setError(error.message||'We could not add that item. Please try again.');}finally{cartBusy=false;quickAdd.disabled=false;}return;}

    if(event.target.closest('.header-bag')&&Number(document.querySelector('.header-bag__count')?.textContent)>0){event.preventDefault();try{await refreshCart();openCartDrawer(event.target.closest('.header-bag'));}catch{location.href=cartUrl('cart');}}
  });

  document.addEventListener('change',async event=>{
    const input=event.target.closest('#CartForm input[name="updates[]"]');if(!input)return;
    const line=input.closest('[data-cart-page-line]');const key=line?.dataset.lineKey;
    if(!key)return;
    try{const response=await fetch(cartUrl('cart/change.js'),{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},credentials:'same-origin',body:JSON.stringify({id:key,quantity:Math.max(0,Number(input.value)||0)})});if(!response.ok)throw new Error();await refreshCart();}catch{location.reload();}
  });

  closeButton.addEventListener('click',()=>closeCartDrawer());
  backdrop.addEventListener('click',()=>closeCartDrawer({restoreFocus:false}));
  cartDrawer.querySelector('[data-cart-continue]').addEventListener('click',()=>closeCartDrawer());
  cartDrawer.addEventListener('scroll',()=>{cartDrawer.querySelectorAll('.cart-drawer-recommendations').forEach(updateCartCarousel);},{passive:true});
  cartDrawer.querySelectorAll('.cart-drawer-recommendations').forEach(carousel=>{const track=carousel.querySelector('[data-cart-recommendation-track], [data-cart-picks-track]');track?.addEventListener('scroll',()=>updateCartCarousel(carousel),{passive:true});});
  window.addEventListener('resize',()=>cartDrawer.querySelectorAll('.cart-drawer-recommendations').forEach(updateCartCarousel),{passive:true});
  document.addEventListener('keydown',event=>{
    if(cartDrawer.hidden)return;
    if(event.key==='Escape'){event.preventDefault();closeCartDrawer();return;}
    if(event.key==='Tab'){
      const focusable=[...cartDrawer.querySelectorAll('a[href],button:not(:disabled),input:not(:disabled),[tabindex]:not([tabindex="-1"])')].filter(node=>!node.hidden);
      if(!focusable.length)return;
      if(event.shiftKey&&document.activeElement===focusable[0]){event.preventDefault();focusable.at(-1).focus();}
      else if(!event.shiftKey&&document.activeElement===focusable.at(-1)){event.preventDefault();focusable[0].focus();}
    }
  });
  cartDrawer.querySelectorAll('.cart-drawer-recommendations').forEach(updateCartCarousel);
}

/* Collection filter controls: native Shopify filters remain the source of truth. */
document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-filter-toggle]');
  if (toggle) {
    const panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;
    const open = !panel.classList.contains('is-open');
    panel.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('collection-filter-open', open);
    if (open) panel.querySelector('[data-filter-close]')?.focus();
    return;
  }
  const close = event.target.closest('[data-filter-close]');
  if (close) {
    const panel = close.closest('[data-filter-panel]');
    const toggleButton = document.querySelector(`[aria-controls="${panel?.id}"][data-filter-toggle]`);
    panel?.classList.remove('is-open');
    toggleButton?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('collection-filter-open');
    toggleButton?.focus();
  }
});

document.addEventListener('change', (event) => {
  if (event.target.matches('[data-collection-sort]')) event.target.form?.requestSubmit();
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const panel = document.querySelector('[data-filter-panel].is-open');
  if (!panel) return;
  panel.classList.remove('is-open');
  document.querySelector(`[aria-controls="${panel.id}"][data-filter-toggle]`)?.setAttribute('aria-expanded', 'false');
  document.body.classList.remove('collection-filter-open');
});
